<section>
  @if (total() <= 0) {
    <div class="flex-align-center-center">
      <h1>Nu există rezultate</h1>
    </div>
  }
  @if (total() > 0) {
    <div class="rezultat-body">
      <div class="flex-align-center-center">
        <mat-form-field class="flex-40"><mat-label>Filtrează datele tabelului</mat-label>
        <input matInput type="text" (keyup)="doFilter($any($event.target).value)"
          >
      </mat-form-field>
    </div>
    @if (pagini()>= 2) {
      <div class="flex-align-center-center">
        <div class="paginare">
            @if (currentPage() >= 2) {
              <button mat-icon-button type="button" (click)="getNewPage(prevPage(), 'cmr')" color="primary" aria-label="Pagina anterioară">
                <mat-icon>keyboard_arrow_left</mat-icon>
              </button>
            }
            <button mat-button color="primary" [disabled]="true">Pagina {{currentPage()}} din {{pagini()}}</button>
            @if (currentPage() < pagini()) {
              <button mat-icon-button type="button" (click)="getNewPage(nextPage(), 'cmr')" color="primary" aria-label="Pagina următoare">
                <mat-icon>keyboard_arrow_right</mat-icon>
              </button>
            }
        </div>
      </div>
    }
    <div class="table-container">
      <table mat-table [dataSource]="dataSource" matSort style="width: 100%">
        <ng-container matColumnDef="status_icon">
          <!-- <mat-header-cell *matHeaderCellDef mat-sort-header></mat-header-cell>
          <mat-cell *matCellDef="let element">
            <mat-icon *ngIf="element.status === 1" color='primary'>check_circle</mat-icon>
            <mat-icon *ngIf="element.status === 2" color='warn'>error_outline</mat-icon>
            <mat-icon *ngIf="element.status === 3">check_circle</mat-icon>
            <mat-icon *ngIf="element.status === 6" color='warn'>autorenew</mat-icon>
            <mat-icon *ngIf="element.status === 11">access_time</mat-icon>
          </mat-cell> -->
          <th mat-header-cell *matHeaderCellDef><span class="cdk-visually-hidden">Iconiță status</span></th>
          <td mat-cell *matCellDef="let element">
            <mat-icon [color]="getColor(element.status_id)">{{regServ.iconMedicStatus(element.status_id)}}</mat-icon>
          </td>
        </ng-container>
        <ng-container matColumnDef="judet">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Județ</th>
          <td mat-cell *matCellDef="let element">{{ element.judet_id | judet }}</td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
          <td mat-cell *matCellDef="let element">{{ element.status_id | medic_status }}</td>
        </ng-container>
        <ng-container matColumnDef="nume">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Nume</th>
          <td mat-cell *matCellDef="let element">{{ element.nume }}</td>
        </ng-container>
        <ng-container matColumnDef="prenume">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Prenume</th>
          <td mat-cell *matCellDef="let element">{{ element.prenume }}</td>
        </ng-container>
        <ng-container matColumnDef="nume_anterior">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>N. Anterior</th>
          <td mat-cell *matCellDef="let element">{{ element.nume_anterior }}</td>
        </ng-container>
        <ng-container matColumnDef="cuim">
          <th mat-header-cell *matHeaderCellDef>C.U.I.M</th>
          <td mat-cell *matCellDef="let element">{{ element.cuim }}</td>
        </ng-container>
        <ng-container matColumnDef="cnp">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>C.N.P</th>
          <td mat-cell *matCellDef="let element">{{ element.cnp }}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="row-pointer"
        [class.highlight]="selectedRowIndex() === row.id" (click)="clickRow(row)"></tr>
      </table>
    </div>
  </div>
}
</section>